<template>
    <div id="page-header" >
        <div class="container-fluid" >
            <div class="page-header-wrapper">
                <div class="page-header-content" :style="{textAlign: 'left'}">
                    <h1 v-if="isSingle">{{ title }}</h1>
                    <h1 v-else>{{ title }}</h1>
                    <br/>
                    <h5>
                        <div v-if="!isSingle" v-safe-html="content" />

                    </h5>
                </div>
                <div v-if="thumbnailUrl" class="page-header-image">
                    <img :src="photo" :alt="title" />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        photo: String,
        title: String,
        content: String,
    },
    data() {
        return {
            isSingle: false, // Set this based on your logic
            thumbnailUrl: require('@/assets/404.jpg'),
        };
    },
    
    methods: {
    },
};
</script>

<style>
@import '@/css/main.css';

/* Contained two-column layout aligned to the site container.
   Removes the big left gap caused by margin-left:auto (main.css) plus the old
   18rem hack, which pushed the text column far to the right. */
#page-header .page-header-wrapper {
    max-width: 1140px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}

#page-header .page-header-wrapper .page-header-content {
    width: 50%;
    margin-left: 0 !important;
    padding-right: 48px;
}

@media all and (max-width: 767px) {
    #page-header .page-header-wrapper {
        padding-left: 0;
        padding-right: 0;
    }

    #page-header .page-header-wrapper .page-header-content {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
    }
}
</style>